import * as React from 'react';
import Grid from './Grid';
import Panel from './Panel';
import MapPanel from './MapPanel';
import PublicFooter from './PublicFooter';
import PublicHeader from './PublicHeader';

export interface Props {
  countries: string[];
  cups: number;
  coffee: number;
  water: number;
  ratio: number;
  brew_methods: string[];
}

const Caption = (props: any) => (
  <React.Fragment>
    <h1 className="f1-l f2-m f3 lh-title ma0">{props.title}</h1>
    <p className="f5 f4-ns lh-copy black-70 ma0">{props.subtitle}</p>
  </React.Fragment>
);

const methoURLs: any = {
  'Hario V60': 'static-hariov60',
  AeroPress: 'static-aeropress',
  Chemex: 'static-chemex',
};

const BrewMethod = (props: { name: string }) => (
  <a
    href={`https://guides.filtru.coffee/${methoURLs[props.name]}`}
    className="link tc dim"
  >
    <img
      className="db br-100 w3 w4-ns ml-auto mr-auto"
      src={`/images/methods/${props.name}.png`}
    />
    <p className="f5 f4-ns lh-copy black-70 mv2">{props.name}</p>
  </a>
);

/**
 * Formats Coffee for display
 */
const formatCoffee = (value: number) => `${(value / 1000).toFixed(1)} kg`;
/**
 * Formats Water for display
 */
const formatWater = (value: number) => `${(value / 1000).toFixed(1)} L`;
/**
 * Formats Cups for display
 */
const formatCups = (value: number) => `${Math.round(value)} cups`;
/**
 * Formats Ratio for display
 */
const formatRatio = (value: number) => `1:${Math.round(value)}`;

const btnClasses =
  'db br-pill bw1 b--current ph4 pv2 link bg-transparent tc dim pointer ba silver hover-gold';

export const TodayPage = (props: Props) => {
  return (
    <div className="w-100 sans-serif">
      <PublicHeader
        title="Today on Filtru"
        subtitle="Explore the rapidly growing coffee community"
      />
      <div className="flex flex-row-ns flex-column items-center justify-center ma3 mt4 mh0-ns">
        <div className="mr2 ml2 mb2 mb0-ns w-100-s">
          <a className={btnClasses} href="https://getfiltru.com">
            Get the app
          </a>
        </div>
        <div className="mr2 ml2 mb2 mb0-ns w-100-s">
          <a className={btnClasses} href="https://guides.filtru.coffee">
            Brew Guides
          </a>
        </div>
        <div className="mr2 ml2 mb2 mb0-ns w-100-s">
          <a className={btnClasses} href="https://business.filtru.coffee">
            Coffee Roasters
          </a>
        </div>
      </div>
      <article className="bg-white black mw9 ml-auto mr-auto">
        <section id="features" className="pv5 pa3 pa5-ns">
          <Grid>
            <Panel className="column-start-1 column-end-3-m column-start-2-l column-end-4-l row-start-1-l row-end-3-l">
              <div className="tc flex flex-column justify-center aspect-ratio--object">
                <MapPanel highlighted={props.countries} />
                <Caption
                  title="In every corner of the world"
                  subtitle={`Coffee afficionados from over ${props.countries.length} countries`}
                />
              </div>
            </Panel>
            <Panel>
              <div
                className="tc flex flex-column justify-center aspect-ratio--object cover"
                style={{
                  backgroundImage: 'url(/images/drawings/cups-artwork.png)',
                }}
              >
                <Caption
                  title={formatCups(props.cups)}
                  subtitle="consumed in the last 24 hours"
                />
              </div>
            </Panel>
            <Panel>
              <div
                className="tc flex flex-column justify-center aspect-ratio--object cover"
                style={{
                  backgroundImage: 'url(/images/drawings/coffee-artwork.png)',
                }}
              >
                <Caption
                  title={formatCoffee(props.coffee)}
                  subtitle="of ground coffee brewed"
                />
              </div>
            </Panel>
            <Panel className="column-start-1 column-end-3-ns row-start-3-l row-end-5-l">
              <div className="tc flex flex-column justify-center aspect-ratio--object">
                <div className="tc flex justify-around items-center mb3 mb4-m mb6-l">
                  {props.brew_methods.map((method) => (
                    <BrewMethod key={method} name={method} />
                  ))}
                </div>
                <Caption
                  title="Most popular brew methods"
                  subtitle="with many brew guides created by Filtru users"
                />
              </div>
            </Panel>
            <Panel>
              <div
                className="tc flex flex-column justify-center aspect-ratio--object cover"
                style={{
                  backgroundImage: 'url(/images/drawings/water-artwork.png)',
                }}
              >
                <Caption
                  title={formatWater(props.water)}
                  subtitle="poured in the last 24 hours"
                />
              </div>
            </Panel>
            <Panel>
              <div
                className="tc flex flex-column justify-center aspect-ratio--object cover"
                style={{
                  backgroundImage: 'url(/images/drawings/ratio-artwork.png)',
                }}
              >
                <Caption
                  title={formatRatio(props.ratio)}
                  subtitle="Most used brew ratio"
                />
              </div>
            </Panel>
          </Grid>
          <p className="f5 lh-copy black-70 mv3">
            * Data represents the usage of Filtru Coffee app in the past 24
            hours
          </p>
        </section>
      </article>
      <PublicFooter />
    </div>
  );
};

export default TodayPage;
